// Generated by mwitc Code Generator 1.1.1 by Michael Wittmer)
// Do NOT modify this code, since it will be overwritten the next time the code will be generated
"use strict"

function o2n(value) { return (value ?? 0) < 0 ? null : value; } // omit value (-1) in Summen wie null behandeln

export function Erhebung_PrepareRows(rows) {
  rows[0].shortName = "1";
  rows[0].label = "Verwaltungen und Betriebe, soweit nicht unter Zeilen 4, 8, 12 bis 18 aufgeführt <b>(TVöD-V)</b>";
  rows[0].labeltext = "Verwaltungen und Betriebe, soweit nicht unter Zeilen 4, 8, 12 bis 18 aufgeführt (TVöD-V)";
  rows[0].annotationId = "4";
  rows[1].shortName = "2";
  rows[1].label = "<b><u>von Zeile 1</u></b> TVöD-V <b>Sozial-und Erziehungsdienst</b>";
  rows[1].labeltext = "von Zeile 1 TVöD-V Sozial-und Erziehungsdienst";
  rows[1].annotationId = "5";
  rows[1].maxRowRefId = "TVoeDV";
  rows[1].gesamtsumme = -1;
  rows[2].shortName = "3";
  rows[2].label = "<b><u>von Zeile 1</u></b> TVöD-V <b>Öffentlicher Gesundheitsdienst</b>";
  rows[2].labeltext = "von Zeile 1 TVöD-V Öffentlicher Gesundheitsdienst";
  rows[2].annotationId = "5";
  rows[2].maxRowRefId = "TVoeDV";
  rows[2].az_BBIG = -1;
  rows[2].az_Pflege = -1;
  rows[2].az_Praktikanten = -1;
  rows[2].az_TVSöD = -1;
  rows[2].az_TVHöD = -1;
  rows[2].az_DualPflege = -1;
  rows[2].az_DualTVöDV = -1;
  rows[2].az_Sonstige = -1;
  rows[2].az_Summe = -1;
  rows[2].gesamtsumme = -1;
  rows[3].shortName = "4";
  rows[3].label = "Krankenhäuser <b>(TVöD-K) insgesamt</b>";
  rows[3].labeltext = "Krankenhäuser (TVöD-K) insgesamt";
  rows[3].annotationId = "6";
  rows[4].shortName = "5";
  rows[4].label = "<b><u>von Zeile 4</u></b> TVöD-K <b>Pflegedienst</b>";
  rows[4].labeltext = "von Zeile 4 TVöD-K Pflegedienst";
  rows[4].annotationId = "7";
  rows[4].maxRowRefId = "TVoeDK";
  rows[4].az_BBIG = -1;
  rows[4].az_Pflege = -1;
  rows[4].az_Praktikanten = -1;
  rows[4].az_TVSöD = -1;
  rows[4].az_TVHöD = -1;
  rows[4].az_DualPflege = -1;
  rows[4].az_DualTVöDV = -1;
  rows[4].az_Sonstige = -1;
  rows[4].az_Summe = -1;
  rows[4].gesamtsumme = -1;
  rows[5].shortName = "6";
  rows[5].label = "<b><u>von Zeile 4</u></b> TVöD-K <b>(Zahn-)Ärztinnen und Ärzte</b>";
  rows[5].labeltext = "von Zeile 4 TVöD-K (Zahn-)Ärztinnen und Ärzte";
  rows[5].annotationId = "7";
  rows[5].maxRowRefId = "TVoeDK";
  rows[5].az_BBIG = -1;
  rows[5].az_Pflege = -1;
  rows[5].az_Praktikanten = -1;
  rows[5].az_TVSöD = -1;
  rows[5].az_TVHöD = -1;
  rows[5].az_DualPflege = -1;
  rows[5].az_DualTVöDV = -1;
  rows[5].az_Sonstige = -1;
  rows[5].az_Summe = -1;
  rows[5].gesamtsumme = -1;
  rows[6].shortName = "7";
  rows[6].label = "Ärztinnen und Ärzte an kommunalen Krankenhäusern <b>(TV-Ärzte/VKA)</b>";
  rows[6].labeltext = "Ärztinnen und Ärzte an kommunalen Krankenhäusern (TV-Ärzte/VKA)";
  rows[6].az_BBIG = -1;
  rows[6].az_Pflege = -1;
  rows[6].az_Praktikanten = -1;
  rows[6].az_TVSöD = -1;
  rows[6].az_TVHöD = -1;
  rows[6].az_DualPflege = -1;
  rows[6].az_DualTVöDV = -1;
  rows[6].az_Sonstige = -1;
  rows[6].az_Summe = -1;
  rows[7].shortName = "8";
  rows[7].label = "Pflege und Betreuungseinrichtungen <b>(TVöD-B) insgesamt</b>";
  rows[7].labeltext = "Pflege und Betreuungseinrichtungen (TVöD-B) insgesamt";
  rows[7].annotationId = "8";
  rows[8].shortName = "9";
  rows[8].label = "<b><u>von Zeile 8</u></b> <b>TVöD-B Pflegedienst</b>";
  rows[8].labeltext = "von Zeile 8 TVöD-B Pflegedienst";
  rows[8].annotationId = "9";
  rows[8].maxRowRefId = "TVoeDB";
  rows[8].az_BBIG = -1;
  rows[8].az_Pflege = -1;
  rows[8].az_Praktikanten = -1;
  rows[8].az_TVSöD = -1;
  rows[8].az_TVHöD = -1;
  rows[8].az_DualPflege = -1;
  rows[8].az_DualTVöDV = -1;
  rows[8].az_Sonstige = -1;
  rows[8].az_Summe = -1;
  rows[8].gesamtsumme = -1;
  rows[9].shortName = "10";
  rows[9].label = "<b><u>von Zeile 8</u></b> TVöD-B <b>Sozial- und Erziehungsdienst</b>";
  rows[9].labeltext = "von Zeile 8 TVöD-B Sozial- und Erziehungsdienst";
  rows[9].annotationId = "9";
  rows[9].maxRowRefId = "TVoeDB";
  rows[9].gesamtsumme = -1;
  rows[10].shortName = "11";
  rows[10].label = "<b><u>von Zeile 8</u></b> TVöD-B <b>(Zahn-)Ärztinnen und Ärzte</b>";
  rows[10].labeltext = "von Zeile 8 TVöD-B (Zahn-)Ärztinnen und Ärzte";
  rows[10].annotationId = "9";
  rows[10].maxRowRefId = "TVoeDB";
  rows[10].az_BBIG = -1;
  rows[10].az_Pflege = -1;
  rows[10].az_Praktikanten = -1;
  rows[10].az_TVSöD = -1;
  rows[10].az_TVHöD = -1;
  rows[10].az_DualPflege = -1;
  rows[10].az_DualTVöDV = -1;
  rows[10].az_Sonstige = -1;
  rows[10].az_Summe = -1;
  rows[10].gesamtsumme = -1;
  rows[11].shortName = "12";
  rows[11].label = "Sparkassen <b>(TVöD-S)</b>";
  rows[11].labeltext = "Sparkassen (TVöD-S)";
  rows[12].shortName = "13";
  rows[12].label = "Flughäfen <b>(TVöD-F)</b>";
  rows[12].labeltext = "Flughäfen (TVöD-F)";
  rows[13].shortName = "14";
  rows[13].label = "Flughäfen <b>(Tarifverträge BVD)</b>";
  rows[13].labeltext = "Flughäfen (Tarifverträge BVD)";
  rows[14].shortName = "15";
  rows[14].label = "Entsorgung <b>(TVöD-E oder anderes Tarifrecht)</b>";
  rows[14].labeltext = "Entsorgung (TVöD-E oder anderes Tarifrecht)";
  rows[14].annotationId = "10";
  rows[15].shortName = "16";
  rows[15].label = "Versorgung <b>(TV-V oder anderes Tarifrecht)</b>";
  rows[15].labeltext = "Versorgung (TV-V oder anderes Tarifrecht)";
  rows[15].annotationId = "11";
  rows[16].shortName = "17";
  rows[16].label = "Nahverkehr und Häfen <b>(TV-N oder anderes Tarifrecht)</b>";
  rows[16].labeltext = "Nahverkehr und Häfen (TV-N oder anderes Tarifrecht)";
  rows[16].annotationId = "12";
  rows[17].shortName = "18";
  rows[17].label = "Forstwirtschaft, soweit nicht TVöD";
  rows[17].labeltext = "Forstwirtschaft, soweit nicht TVöD";
  rows[17].annotationId = "13";
  rows[18].shortName = "19";
  rows[18].label = "Fleischuntersuchung <b>(TV Fleischuntersuchung)</b>";
  rows[18].labeltext = "Fleischuntersuchung (TV Fleischuntersuchung)";
  rows[19].shortName = "20";
  rows[19].label = "<b>Gesamtzahl (Zeilen 1-19, ohne die Zahlen der Zeilen 2, 3, 5, 6, 9, 10 und 11)</b>";
  rows[19].labeltext = "Gesamtzahl (Zeilen 1-19, ohne die Zahlen der Zeilen 2, 3, 5, 6, 9, 10 und 11)";
  rows[19].annotationId = "14";
}


export function Erhebung_DataColumnConfiguration() {
  if (Erhebung_Info.columnConfig) { return Erhebung_Info.columnConfig; }
  let config = [
    {
      caption: '',
      columns: [
        {
          caption: 'A',
          columns: [
            {
              caption: 'Nr',
              allowEditing: false,
              dataField: "shortName"
            }
          ]
        },
        {
          caption: 'B',
          columns: [
            {
              caption: 'Sparte',
              allowEditing: false,
              dataField: "label"
            }
          ]
        },
      ]
    },
    {
      caption: 'Beschäftigte',
      columns:[
        {
          caption: 'C',
          columns:[
            {
              caption: '<b>Vollzeit</b>',
              dataField: 'bs_Vollzeit',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'Vollzeit',
                widthHint: 0,
                labeltext: "Vollzeit"
              },
              allowEditing: true
            }
          ]
        }, 
        {
          caption: 'D',
          columns:[
            {
              caption: '<b>Teilzeit</b>',
              dataField: 'bs_Teilzeit',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'Teilzeit',
                widthHint: 0,
                annotationId: 1,
                labeltext: "Teilzeit"
              },
              allowEditing: true
            }
          ]
        }, 
        {
          caption: 'E',
          columns:[
            {
              caption: '<b>Nicht unter den Geltungs&shy;bereich der TVe fallend</b>',
              dataField: 'bs_NGb',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'NGb',
                widthHint: 2,
                annotationId: 2,
                labeltext: "Nicht unter den Geltungs&shy;bereich der TVe fallend"
              },
              allowEditing: true
            }
          ]
        }, 
        {
          caption: 'F',
          columns:[
            {
              caption: '<b>Beschäftigte insgesamt</b>',
              dataField: 'bs_Summe',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'BSum',
                widthHint: 1.25,
                labeltext: "insgesamt"
              },
              allowEditing: false
            }
          ]
        }
      ]
    }, 
    {
      caption: 'Auszubildende',
      columns:[
        {
          caption: 'G',
          columns:[
            {
              caption: '<b>TVAöD (BBIG)</b>',
              dataField: 'az_BBIG',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'BBIG',
                widthHint: 0,
                labeltext: "TVAöD (BBIG)"
              },
              allowEditing: true
            }
          ]
        }, 
        {
          caption: 'H',
          columns:[
            {
              caption: '<b>TVAöD (Pflege)</b>',
              dataField: 'az_Pflege',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'Pflege',
                widthHint: 0,
                labeltext: "TVAöD (Pflege)"
              },
              allowEditing: true
            }
          ]
        }, 
        {
          caption: 'I',
          columns:[
            {
              caption: '<b>TVPöD (Prak&shy;tikanten)</b>',
              dataField: 'az_Praktikanten',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'Prakt',
                widthHint: 1,
                labeltext: "TVPöD (Prak&shy;tikanten)"
              },
              allowEditing: true
            }
          ]
        }, 
        {
          caption: 'J',
          columns:[
            {
              caption: '<b>Dual Studierende (TVSöD)</b>',
              dataField: 'az_TVSöD',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'TVSöD',
                widthHint: 0.8,
                labeltext: "Dual Studierende (TVSöD)"
              },
              allowEditing: true
            }
          ]
        }, 
        {
          caption: 'K',
          columns:[
            {
              caption: '<b>Dual Studierende (TVHöD)</b>',
              dataField: 'az_TVHöD',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'TVHöD',
                widthHint: 0.8,
                labeltext: "Dual Studierende (TVHöD)"
              },
              allowEditing: true
            }
          ]
        }, 
        {
          caption: 'L',
          columns:[
            {
              caption: '<b>Dual Studierende Studien&shy;richt&shy;linie duales Pflegestudium</b>',
              dataField: 'az_DualPflege',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'DualPflege',
                widthHint: 1.75,
                labeltext: "Dual Studierende Studien&shy;richt&shy;linie duales Pflegestudium"
              },
              allowEditing: true
            }
          ]
        }, 
        {
          caption: 'M',
          columns:[
            {
              caption: '<b>Dual Studierende Studien&shy;richt&shy;linie TVöD-V</b>',
              dataField: 'az_DualTVöDV',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'DualTVöDV',
                widthHint: 1,
                labeltext: "Dual Studierende Studien&shy;richt&shy;linie TVöD-V"
              },
              allowEditing: true
            }
          ]
        }, 
        {
          caption: 'N',
          columns:[
            {
              caption: '<b>Sonstige Personen</b>',
              dataField: 'az_Sonstige',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'Sonst',
                widthHint: 1.1,
                annotationId: 3,
                labeltext: "Sonstige Personen"
              },
              allowEditing: true
            }
          ]
        }, 
        {
          caption: 'O',
          columns:[
            {
              caption: '<b>Azubis insgesamt</s>',
              dataField: 'az_Summe',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'AzSum',
                widthHint: 1.1,
                labeltext: "Azubis gesamt"
              },
              allowEditing: false
            }
          ]
        }
      ]
    }, 
    {
      caption: 'Gesamtsumme',
      columns:[
        {
          caption: 'P',
          columns:[
            {
              caption: '<b>Beschäftigte und Azubis insgesamt</b>',
              dataField: 'gesamtsumme',
              customizeText(e) { return e.value === -1 ? '' : e.valueText; } ,
              mwitc: {
                id: 'Gesamtsumme',
                widthHint: 2,
                labeltext: "Beschäftigte und Azubis insgesamt"
              },
              allowEditing: false
            }
          ]
        }
      ]
    }
  ];  
  Erhebung_Info.columnConfig = config;
  return config;
}
export const Erhebung_Info = {
  sumRows: ['Gesamt'],
  omitRows: [
    { rowName: 'TVoeDVSozial', columns: ['gesamtsumme']},
    { rowName: 'TVoeDVGes', columns: ['az_BBIG', 'az_Pflege', 'az_Praktikanten', 'az_TVSöD', 'az_TVHöD', 'az_DualPflege', 'az_DualTVöDV', 'az_Sonstige', 'az_Summe', 'gesamtsumme']},
    { rowName: 'TVoeDKPflege', columns: ['az_BBIG', 'az_Pflege', 'az_Praktikanten', 'az_TVSöD', 'az_TVHöD', 'az_DualPflege', 'az_DualTVöDV', 'az_Sonstige', 'az_Summe', 'gesamtsumme']},
    { rowName: 'TVoeDKArzt', columns: ['az_BBIG', 'az_Pflege', 'az_Praktikanten', 'az_TVSöD', 'az_TVHöD', 'az_DualPflege', 'az_DualTVöDV', 'az_Sonstige', 'az_Summe', 'gesamtsumme']},
    { rowName: 'Aerzte', columns: ['az_BBIG', 'az_Pflege', 'az_Praktikanten', 'az_TVSöD', 'az_TVHöD', 'az_DualPflege', 'az_DualTVöDV', 'az_Sonstige', 'az_Summe']},
    { rowName: 'TVoeDBPflege', columns: ['az_BBIG', 'az_Pflege', 'az_Praktikanten', 'az_TVSöD', 'az_TVHöD', 'az_DualPflege', 'az_DualTVöDV', 'az_Sonstige', 'az_Summe', 'gesamtsumme']},
    { rowName: 'TVoeDBSozial', columns: ['gesamtsumme']},
    { rowName: 'TVoeDBArzt', columns: ['az_BBIG', 'az_Pflege', 'az_Praktikanten', 'az_TVSöD', 'az_TVHöD', 'az_DualPflege', 'az_DualTVöDV', 'az_Sonstige', 'az_Summe', 'gesamtsumme']}
  ],
  annotations: [
    { id: '1', text: 'In der Spalte D sind auch die geringfügig Beschäftigten sowie alle in Altersteilzeit befindlichen Beschäftigten einzutragen, auch soweit sie sich in der Freistellungsphase befinden.' },
    { id: '2', text: 'In der Spalte E sind die Beschäftigten einzutragen, die nicht unter den Geltungsbereich der in den Zeilen Nrn. 1 bis 17 (Personalbestandserhebung) aufgeführten Manteltarifverträge fallen (z.B. Beschäftigte im Sinne des § 1 Abs. 2 TVöD wie leitende Angestellte).' },
    { id: '3', text: 'Sonstige Personen im Sinne der Spalte K sind alle Auszubildenden, die nicht vom TVAöD (BBiG), TVAöD (Pflege), TVSöD oder von dem TVPöD erfasst werden (z.B. Volontäre, PJ-Studierende).' },
    { id: '4', text: 'Hierzu gehören Beschäftigte und Auszubildende der Kommunalverwaltungen und ihrer rechtlich unselbständigen Betriebe sowie sonstiger Verwaltungen, die unter den Geltungsbereich des TVöD-V fallen, nicht aber z.B. das Verwaltungspersonal in einem Krankenhaus oder in einer Pflege- oder Betreuungseinrichtung. Dieses Verwaltungspersonal ist mit in Zeile Nr. 4 bzw. Zeile Nr. 8 aufzuführen.' },
    { id: '5', text: 'Die Zeilen Nrn. 2 und 3 gliedern die Zeile Nr. 1 auf. Die dort aufzuführenden Beschäftigten im Sozial- und Erziehungsdienst (Zeile Nr. 2) und die Beschäftigten im Öffentlichen Gesundheitsdienst (Zeile Nr. 3) müssen also bereits in den Zahlen der Zeile Nr. 1 enthalten sein. Die Zeile 3 umfasst auch Sozialarbeiter im ÖGD.' },
    { id: '6', text: 'Hier sind alle Beschäftigten und Auszubildenden einzutragen, die in einer Einrichtung beschäftigt werden, für die der TVöD-K gilt, unabhängig davon, ob es sich um Verwaltungspersonal, Pflegepersonal oder Ärzte handelt. Erfasst werden mithin alle Beschäftigten in Krankenhäusern, einschließlich psychiatrischen Fachkrankenhäusern, medizinischen Instituten von Krankenhäusern oder sonstigen Einrichtungen (z.B. Reha-Einrichtungen, Kureinrichtungen), in denen die betreuten Personen in ärztlicher Behandlung stehen. Nicht erfasst werden Beschäftigte von Altenheimen, Behinderteneinrichtungen oder Einrichtungen zur Betreuung von Kindern, Jugendlichen sowie obdachlosen, gebrechlichen oder sonstigen hilsbedürftigen Personen, auch wenn diese Einrichtungen mit einem Krankenhaus eine organisatorische Einheit bilden. Die Beschäftigten dieser Einrichtungen, auf die der TVöD-B Anwendung findet, sind in die Zeile Nr. 8 einzutragen.' },
    { id: '7', text: 'Die Zeilen Nrn. 5 und 6 gliedern die Zeile Nr. 4 auf. Die dort aufzuführenden Beschäftigten im Pflegedienst (Zeile Nr. 5) sowie die in Zeile Nr. 6 aufzuführenden Ärzt*innen/Zahnärzt*innen müssen also bereits in den Zahlen der Zeile Nr. 4 enthalten sein.' },
    { id: '8', text: 'Hier sind alle Beschäftigten und Auszubildenden einzutragen, die in einer Einrichtung beschäftigt werden, für die der TVöD-B gilt, unabhängig davon, ob es sich um Verwaltungspersonal, Pflegepersonal oder Ärzte handelt. ' },
    { id: '9', text: 'Die Zeilen Nrn. 9 bis 11 gliedern die Zeile Nr. 8 auf. Die dort aufzuführenden Beschäftigten im Pflegedienst (Zeile Nr. 9), im Sozial- und Erziehungsdienst (Zeile Nr. 10) sowie die in Zeile Nr. 11 aufzuführenden Ärzt*innen/Zahnärzt*innen müssen also bereits in den Zahlen der Zeile Nr. 8 enthalten sein.' },
    { id: '10', text: 'Zu erfassen sind alle Beschäftigten und Auszubildenden im Bereich der Entsorgung, unabhängig davon, ob auf diese der TVöD-E oder ein anderes Tarifrecht als der TVöD-E Anwendung findet. ' },
    { id: '11', text: 'Zu erfassen sind alle Arbeitnehmer und Auszubildenden im Bereich der Versorgung, unabhängig davon, ob auf diese der TV-V oder ein anderes Tarifrecht als der TV-V (z.B. der BAT bzw. BMT-G oder der TVöD) Anwendung findet.' },
    { id: '12', text: 'Zu erfassen sind alle Beschäftigten und Auszubildenden im Bereich der Nahverkehrsbetriebe und Häfen unabhängig davon, ob auf diese der BezTV-N RP oder ein anderes Tarifrecht (z.B. der BAT bzw. BMT-G oder der TVöD) Anwendung findet.' },
    { id: '13', text: 'Beschäftigte in Gärtnereien, gemeindlichen Anlagen und Parks sowie in anlagenmäßig oder parkartig bewirtschafteten Gemeindewäldern werden gem. § 1 Abs. 2 Buchst. q TVöD vom BezTV-W RP nicht erfasst und sind bei den Beschäftigten in der Zeile Nr. 1 einzutragen.' },
    { id: '14', text: 'Bei der Addition der Spalten für die Gesamtzahl ist zu berücksichtigen, dass die in den Zeilen Nrn. 2, 3, 5, 6, 9 bis 11 aufgeführten Zahlen bereits in den Zahlen der Zeilen Nr. 1, 4 und 8 enthalten sind. Die Zeilen Nrn. 2, 3, 5, 6, 9 bis 11 sind deshalb bei der Addition auszusparen.' }
  ],
  totalColumnField: "gesamtsumme",
  totalRowPosition: 19,
  totalRowId: "gesamt"
}
export function Erhebung_ReCalculate(rowTag, data, dataIsRow) {
  // rowTag: Wert des Felds rowTag in der Zeile
  // data: die Daten des Grids (also der Matrix)  bzw. der neu zu berechnenden Zeile (wenn dataIsRow = true)
  let row = dataIsRow ?  data : data.find(o => o.rowTag === rowTag);
  row.bs_Summe = (o2n(row.bs_Vollzeit) == null && o2n(row.bs_Teilzeit) == null && o2n(row.bs_NGb) == null) ? null : (o2n(row.bs_Vollzeit) ?? 0) + (o2n(row.bs_Teilzeit) ?? 0) + (o2n(row.bs_NGb) ?? 0);
  row.az_Summe = (o2n(row.az_BBIG) == null && o2n(row.az_Pflege) == null && o2n(row.az_Praktikanten) == null && o2n(row.az_TVSöD) == null && o2n(row.az_TVHöD) == null && o2n(row.az_DualPflege) == null && o2n(row.az_DualTVöDV) == null && o2n(row.az_Sonstige) == null) ? null : (o2n(row.az_BBIG) ?? 0) + (o2n(row.az_Pflege) ?? 0) + (o2n(row.az_Praktikanten) ?? 0) + (o2n(row.az_TVSöD) ?? 0) + (o2n(row.az_TVHöD) ?? 0) + (o2n(row.az_DualPflege) ?? 0) + (o2n(row.az_DualTVöDV) ?? 0) + (o2n(row.az_Sonstige) ?? 0);
  row.gesamtsumme = (o2n(row.bs_Summe) == null && o2n(row.az_Summe) == null) ? null : (o2n(row.bs_Summe) ?? 0) + (o2n(row.az_Summe) ?? 0);
  if (rowTag === 'TVoeDVSozial') {
    row.gesamtsumme = -1;
  }
  if (rowTag === 'TVoeDVGes') {
    row.az_Summe = -1;
    row.gesamtsumme = -1;
  }
  if (rowTag === 'TVoeDKPflege') {
    row.az_Summe = -1;
    row.gesamtsumme = -1;
  }
  if (rowTag === 'TVoeDKArzt') {
    row.az_Summe = -1;
    row.gesamtsumme = -1;
  }
  if (rowTag === 'Aerzte') {
    row.az_Summe = -1;
  }
  if (rowTag === 'TVoeDBPflege') {
    row.az_Summe = -1;
    row.gesamtsumme = -1;
  }
  if (rowTag === 'TVoeDBSozial') {
    row.gesamtsumme = -1;
  }
  if (rowTag === 'TVoeDBArzt') {
    row.az_Summe = -1;
    row.gesamtsumme = -1;
  }
  if (dataIsRow) { return; }
  data[19].bs_Vollzeit = (data[0].bs_Vollzeit == null && data[3].bs_Vollzeit == null && data[6].bs_Vollzeit == null && data[7].bs_Vollzeit == null && data[11].bs_Vollzeit == null && data[12].bs_Vollzeit == null && data[13].bs_Vollzeit == null && data[14].bs_Vollzeit == null && data[15].bs_Vollzeit == null && data[16].bs_Vollzeit == null && data[17].bs_Vollzeit == null && data[18].bs_Vollzeit == null) ? null : (data[0].bs_Vollzeit ?? 0) + (data[3].bs_Vollzeit ?? 0) + (data[6].bs_Vollzeit ?? 0) + (data[7].bs_Vollzeit ?? 0) + (data[11].bs_Vollzeit ?? 0) + (data[12].bs_Vollzeit ?? 0) + (data[13].bs_Vollzeit ?? 0) + (data[14].bs_Vollzeit ?? 0) + (data[15].bs_Vollzeit ?? 0) + (data[16].bs_Vollzeit ?? 0) + (data[17].bs_Vollzeit ?? 0) + (data[18].bs_Vollzeit ?? 0);
  data[19].bs_Teilzeit = (data[0].bs_Teilzeit == null && data[3].bs_Teilzeit == null && data[6].bs_Teilzeit == null && data[7].bs_Teilzeit == null && data[11].bs_Teilzeit == null && data[12].bs_Teilzeit == null && data[13].bs_Teilzeit == null && data[14].bs_Teilzeit == null && data[15].bs_Teilzeit == null && data[16].bs_Teilzeit == null && data[17].bs_Teilzeit == null && data[18].bs_Teilzeit == null) ? null : (data[0].bs_Teilzeit ?? 0) + (data[3].bs_Teilzeit ?? 0) + (data[6].bs_Teilzeit ?? 0) + (data[7].bs_Teilzeit ?? 0) + (data[11].bs_Teilzeit ?? 0) + (data[12].bs_Teilzeit ?? 0) + (data[13].bs_Teilzeit ?? 0) + (data[14].bs_Teilzeit ?? 0) + (data[15].bs_Teilzeit ?? 0) + (data[16].bs_Teilzeit ?? 0) + (data[17].bs_Teilzeit ?? 0) + (data[18].bs_Teilzeit ?? 0);
  data[19].bs_NGb = (data[0].bs_NGb == null && data[3].bs_NGb == null && data[6].bs_NGb == null && data[7].bs_NGb == null && data[11].bs_NGb == null && data[12].bs_NGb == null && data[13].bs_NGb == null && data[14].bs_NGb == null && data[15].bs_NGb == null && data[16].bs_NGb == null && data[17].bs_NGb == null && data[18].bs_NGb == null) ? null : (data[0].bs_NGb ?? 0) + (data[3].bs_NGb ?? 0) + (data[6].bs_NGb ?? 0) + (data[7].bs_NGb ?? 0) + (data[11].bs_NGb ?? 0) + (data[12].bs_NGb ?? 0) + (data[13].bs_NGb ?? 0) + (data[14].bs_NGb ?? 0) + (data[15].bs_NGb ?? 0) + (data[16].bs_NGb ?? 0) + (data[17].bs_NGb ?? 0) + (data[18].bs_NGb ?? 0);
  data[19].bs_Summe = (data[0].bs_Summe == null && data[3].bs_Summe == null && data[6].bs_Summe == null && data[7].bs_Summe == null && data[11].bs_Summe == null && data[12].bs_Summe == null && data[13].bs_Summe == null && data[14].bs_Summe == null && data[15].bs_Summe == null && data[16].bs_Summe == null && data[17].bs_Summe == null && data[18].bs_Summe == null) ? null : (data[0].bs_Summe ?? 0) + (data[3].bs_Summe ?? 0) + (data[6].bs_Summe ?? 0) + (data[7].bs_Summe ?? 0) + (data[11].bs_Summe ?? 0) + (data[12].bs_Summe ?? 0) + (data[13].bs_Summe ?? 0) + (data[14].bs_Summe ?? 0) + (data[15].bs_Summe ?? 0) + (data[16].bs_Summe ?? 0) + (data[17].bs_Summe ?? 0) + (data[18].bs_Summe ?? 0);
  data[19].az_BBIG = (data[0].az_BBIG == null && data[3].az_BBIG == null && data[7].az_BBIG == null && data[11].az_BBIG == null && data[12].az_BBIG == null && data[13].az_BBIG == null && data[14].az_BBIG == null && data[15].az_BBIG == null && data[16].az_BBIG == null && data[17].az_BBIG == null && data[18].az_BBIG == null) ? null : (data[0].az_BBIG ?? 0) + (data[3].az_BBIG ?? 0) + (data[7].az_BBIG ?? 0) + (data[11].az_BBIG ?? 0) + (data[12].az_BBIG ?? 0) + (data[13].az_BBIG ?? 0) + (data[14].az_BBIG ?? 0) + (data[15].az_BBIG ?? 0) + (data[16].az_BBIG ?? 0) + (data[17].az_BBIG ?? 0) + (data[18].az_BBIG ?? 0);
  data[19].az_Pflege = (data[0].az_Pflege == null && data[3].az_Pflege == null && data[7].az_Pflege == null && data[11].az_Pflege == null && data[12].az_Pflege == null && data[13].az_Pflege == null && data[14].az_Pflege == null && data[15].az_Pflege == null && data[16].az_Pflege == null && data[17].az_Pflege == null && data[18].az_Pflege == null) ? null : (data[0].az_Pflege ?? 0) + (data[3].az_Pflege ?? 0) + (data[7].az_Pflege ?? 0) + (data[11].az_Pflege ?? 0) + (data[12].az_Pflege ?? 0) + (data[13].az_Pflege ?? 0) + (data[14].az_Pflege ?? 0) + (data[15].az_Pflege ?? 0) + (data[16].az_Pflege ?? 0) + (data[17].az_Pflege ?? 0) + (data[18].az_Pflege ?? 0);
  data[19].az_Praktikanten = (data[0].az_Praktikanten == null && data[3].az_Praktikanten == null && data[7].az_Praktikanten == null && data[11].az_Praktikanten == null && data[12].az_Praktikanten == null && data[13].az_Praktikanten == null && data[14].az_Praktikanten == null && data[15].az_Praktikanten == null && data[16].az_Praktikanten == null && data[17].az_Praktikanten == null && data[18].az_Praktikanten == null) ? null : (data[0].az_Praktikanten ?? 0) + (data[3].az_Praktikanten ?? 0) + (data[7].az_Praktikanten ?? 0) + (data[11].az_Praktikanten ?? 0) + (data[12].az_Praktikanten ?? 0) + (data[13].az_Praktikanten ?? 0) + (data[14].az_Praktikanten ?? 0) + (data[15].az_Praktikanten ?? 0) + (data[16].az_Praktikanten ?? 0) + (data[17].az_Praktikanten ?? 0) + (data[18].az_Praktikanten ?? 0);
  data[19].az_TVSöD = (data[0].az_TVSöD == null && data[3].az_TVSöD == null && data[7].az_TVSöD == null && data[11].az_TVSöD == null && data[12].az_TVSöD == null && data[13].az_TVSöD == null && data[14].az_TVSöD == null && data[15].az_TVSöD == null && data[16].az_TVSöD == null && data[17].az_TVSöD == null && data[18].az_TVSöD == null) ? null : (data[0].az_TVSöD ?? 0) + (data[3].az_TVSöD ?? 0) + (data[7].az_TVSöD ?? 0) + (data[11].az_TVSöD ?? 0) + (data[12].az_TVSöD ?? 0) + (data[13].az_TVSöD ?? 0) + (data[14].az_TVSöD ?? 0) + (data[15].az_TVSöD ?? 0) + (data[16].az_TVSöD ?? 0) + (data[17].az_TVSöD ?? 0) + (data[18].az_TVSöD ?? 0);
  data[19].az_TVHöD = (data[0].az_TVHöD == null && data[3].az_TVHöD == null && data[7].az_TVHöD == null && data[11].az_TVHöD == null && data[12].az_TVHöD == null && data[13].az_TVHöD == null && data[14].az_TVHöD == null && data[15].az_TVHöD == null && data[16].az_TVHöD == null && data[17].az_TVHöD == null && data[18].az_TVHöD == null) ? null : (data[0].az_TVHöD ?? 0) + (data[3].az_TVHöD ?? 0) + (data[7].az_TVHöD ?? 0) + (data[11].az_TVHöD ?? 0) + (data[12].az_TVHöD ?? 0) + (data[13].az_TVHöD ?? 0) + (data[14].az_TVHöD ?? 0) + (data[15].az_TVHöD ?? 0) + (data[16].az_TVHöD ?? 0) + (data[17].az_TVHöD ?? 0) + (data[18].az_TVHöD ?? 0);
  data[19].az_DualPflege = (data[0].az_DualPflege == null && data[3].az_DualPflege == null && data[7].az_DualPflege == null && data[11].az_DualPflege == null && data[12].az_DualPflege == null && data[13].az_DualPflege == null && data[14].az_DualPflege == null && data[15].az_DualPflege == null && data[16].az_DualPflege == null && data[17].az_DualPflege == null && data[18].az_DualPflege == null) ? null : (data[0].az_DualPflege ?? 0) + (data[3].az_DualPflege ?? 0) + (data[7].az_DualPflege ?? 0) + (data[11].az_DualPflege ?? 0) + (data[12].az_DualPflege ?? 0) + (data[13].az_DualPflege ?? 0) + (data[14].az_DualPflege ?? 0) + (data[15].az_DualPflege ?? 0) + (data[16].az_DualPflege ?? 0) + (data[17].az_DualPflege ?? 0) + (data[18].az_DualPflege ?? 0);
  data[19].az_DualTVöDV = (data[0].az_DualTVöDV == null && data[3].az_DualTVöDV == null && data[7].az_DualTVöDV == null && data[11].az_DualTVöDV == null && data[12].az_DualTVöDV == null && data[13].az_DualTVöDV == null && data[14].az_DualTVöDV == null && data[15].az_DualTVöDV == null && data[16].az_DualTVöDV == null && data[17].az_DualTVöDV == null && data[18].az_DualTVöDV == null) ? null : (data[0].az_DualTVöDV ?? 0) + (data[3].az_DualTVöDV ?? 0) + (data[7].az_DualTVöDV ?? 0) + (data[11].az_DualTVöDV ?? 0) + (data[12].az_DualTVöDV ?? 0) + (data[13].az_DualTVöDV ?? 0) + (data[14].az_DualTVöDV ?? 0) + (data[15].az_DualTVöDV ?? 0) + (data[16].az_DualTVöDV ?? 0) + (data[17].az_DualTVöDV ?? 0) + (data[18].az_DualTVöDV ?? 0);
  data[19].az_Sonstige = (data[0].az_Sonstige == null && data[3].az_Sonstige == null && data[7].az_Sonstige == null && data[11].az_Sonstige == null && data[12].az_Sonstige == null && data[13].az_Sonstige == null && data[14].az_Sonstige == null && data[15].az_Sonstige == null && data[16].az_Sonstige == null && data[17].az_Sonstige == null && data[18].az_Sonstige == null) ? null : (data[0].az_Sonstige ?? 0) + (data[3].az_Sonstige ?? 0) + (data[7].az_Sonstige ?? 0) + (data[11].az_Sonstige ?? 0) + (data[12].az_Sonstige ?? 0) + (data[13].az_Sonstige ?? 0) + (data[14].az_Sonstige ?? 0) + (data[15].az_Sonstige ?? 0) + (data[16].az_Sonstige ?? 0) + (data[17].az_Sonstige ?? 0) + (data[18].az_Sonstige ?? 0);
  data[19].az_Summe = (data[0].az_Summe == null && data[3].az_Summe == null && data[7].az_Summe == null && data[11].az_Summe == null && data[12].az_Summe == null && data[13].az_Summe == null && data[14].az_Summe == null && data[15].az_Summe == null && data[16].az_Summe == null && data[17].az_Summe == null && data[18].az_Summe == null) ? null : (data[0].az_Summe ?? 0) + (data[3].az_Summe ?? 0) + (data[7].az_Summe ?? 0) + (data[11].az_Summe ?? 0) + (data[12].az_Summe ?? 0) + (data[13].az_Summe ?? 0) + (data[14].az_Summe ?? 0) + (data[15].az_Summe ?? 0) + (data[16].az_Summe ?? 0) + (data[17].az_Summe ?? 0) + (data[18].az_Summe ?? 0);
  data[19].gesamtsumme = (data[0].gesamtsumme == null && data[3].gesamtsumme == null && data[6].gesamtsumme == null && data[7].gesamtsumme == null && data[11].gesamtsumme == null && data[12].gesamtsumme == null && data[13].gesamtsumme == null && data[14].gesamtsumme == null && data[15].gesamtsumme == null && data[16].gesamtsumme == null && data[17].gesamtsumme == null && data[18].gesamtsumme == null) ? null : (data[0].gesamtsumme ?? 0) + (data[3].gesamtsumme ?? 0) + (data[6].gesamtsumme ?? 0) + (data[7].gesamtsumme ?? 0) + (data[11].gesamtsumme ?? 0) + (data[12].gesamtsumme ?? 0) + (data[13].gesamtsumme ?? 0) + (data[14].gesamtsumme ?? 0) + (data[15].gesamtsumme ?? 0) + (data[16].gesamtsumme ?? 0) + (data[17].gesamtsumme ?? 0) + (data[18].gesamtsumme ?? 0);
}
